@if ((loadingScreenService.loading$ | async)) {
  <app-loading-screen></app-loading-screen>
}
<router-outlet></router-outlet>
